import * as React from "react";
import { IntlProvider as AppIntlProvider } from "@emisgroup/acp-application-intl";
import feasibilityAppMessages from "./locales/en-GB/feasibilityAppTranslation.json";
import { IChildrenProp } from "./Types";

export const applicationNamespace = "App";

export const resources = {
  "en-GB": {
    [applicationNamespace]: feasibilityAppMessages
  }
};

type Props =  IChildrenProp;

/**
 * Responsible for rendering the IntlProvider component
 */
const IntlProvider: React.FC<Props> = (props: Props) => {

  return (
    <AppIntlProvider resources={resources} defaultNS={applicationNamespace}>
      {props.children}
    </AppIntlProvider>
  );
};

export { IntlProvider };
